import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { Bell, ChevronDown, Download, Sparkles } from "lucide-react";
import "./PageActionMenu.css";

export const PageActionMenu = ({
  onPromptHub,
  onDownload,
  onDownloadCurrentPage,
  onClientAlertsTab,
  promptLabel = "Prompt Hub",
  downloadLabel = "Download CSV",
  downloadCurrentPageLabel = "Download Current Page",
  clientAlertsTabLabel = "Client Alerts Tab",
  triggerLabel = "Actions",
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePromptClick = () => {
    handleClose();
    onPromptHub?.();
  };

  const handleDownloadClick = () => {
    handleClose();
    onDownload?.();
  };

  const handleDownloadCurrentPageClick = () => {
    handleClose();
    onDownloadCurrentPage?.();
  };

  const handleClientAlertsTabClick = () => {
    handleClose();
    onClientAlertsTab?.();
  };

  return (
    <div className="page-action-menu">
      <button
        type="button"
        className="page-action-menu__trigger"
        onClick={handleOpen}
        aria-haspopup="menu"
        aria-expanded={isOpen ? "true" : "false"}
        aria-label={triggerLabel}
      >
        <span className="page-action-menu__trigger-text">{triggerLabel}</span>
        <ChevronDown size={16} strokeWidth={2} />
      </button>

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        slotProps={{
          paper: {
            className: "page-action-menu__paper",
          },
          list: {
            className: "page-action-menu__list",
          },
        }}
      >
        {onPromptHub ? (
          <MenuItem className="page-action-menu__item" onClick={handlePromptClick}>
            <Sparkles size={16} strokeWidth={1.9} />
            <span>{promptLabel}</span>
          </MenuItem>
        ) : null}
        {onDownload ? (
          <MenuItem className="page-action-menu__item" onClick={handleDownloadClick}>
            <Download size={16} strokeWidth={1.9} />
            <span>{downloadLabel}</span>
          </MenuItem>
        ) : null}
        {onDownloadCurrentPage ? (
          <MenuItem className="page-action-menu__item" onClick={handleDownloadCurrentPageClick}>
            <Download size={16} strokeWidth={1.9} />
            <span>{downloadCurrentPageLabel}</span>
          </MenuItem>
        ) : null}
        {onClientAlertsTab ? (
          <MenuItem className="page-action-menu__item" onClick={handleClientAlertsTabClick}>
            <Bell size={16} strokeWidth={1.9} />
            <span>{clientAlertsTabLabel}</span>
          </MenuItem>
        ) : null}
      </Menu>
    </div>
  );
};
